import React, { useState, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Box,
  Alert,
  Typography,
} from "@mui/material";
import StudyDropDown from "../../../common/components/StudyDropDown";
import { useRegisterStudentsQuery } from "../../../api/useCreateStudentList";

const UserDialog = ({ isModalOpen, closeModal }) => {
  const [formData, setFormData] = useState({
    studyId: "",
    studentList: [],
  });

  const [selectedStudy, setSelectedStudy] = useState("");
  const [userList, setUserList] = useState([]);
  const [duplicateEmails, setDuplicateEmails] = useState([]);
  const [duplicateNames, setDuplicateNames] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const queryClient = useQueryClient();
  const { mutate, isPending, isError, error } = useRegisterStudentsQuery();
  const handleStudyChange = (event) => {
    setSelectedStudy(event.target.value);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const paste = event.clipboardData.getData("text");
    const rows = paste.split("\n").map((row) => row.split("\t"));
    const newUserList = rows.map((row, index) => ({
      id: index + 1,
      name: row[0],
      email: row[1],
      region: row[2],
    }));
    setUserList(newUserList);
  };

  useEffect(() => {
    const emails = userList.map((user) => user.email);
    const names = userList.map((user) => user.name);
    setDuplicateEmails(
      emails.filter((email, index) => emails.indexOf(email) !== index)
    );
    setDuplicateNames(
      names.filter((name, index) => names.indexOf(name) !== index)
    );
  }, [userList]);

  const handleUserChange = (index, field, value) => {
    const updatedUserList = [...userList];
    updatedUserList[index][field] = value;
    setUserList(updatedUserList);
  };
  const handleAddStudents = async () => {
    if (
      window.confirm(
        `${userList.length}명의 학생을 ${selectedStudy.title}로 등록하시겠습니까?`
      )
    ) {
      mutate(
        { studyId: selectedStudy._id, studentList: userList },
        {
          onSuccess: () => {
            closeModal(); // 성공 시 모달 닫기
            queryClient.invalidateQueries("users");
          },
          onError: (error) => {
            setErrorMessage(
              error.response.data.message || "등록에 실패했습니다."
            ); // 실패 시 에러 메시지 설정
          },
        }
      );
    }
  };
  return (
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>유저 대량 추가</DialogTitle>
      <DialogContent>
        {/* 에러 메시지가 있을 경우 Alert 컴포넌트로 표시 */}
        {isError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <FormControl fullWidth margin="normal">
          <StudyDropDown
            selectedStudy={selectedStudy}
            handleStudyChange={handleStudyChange}
          />
        </FormControl>
        <Typography>학생 수: {userList.length}</Typography>
        {duplicateEmails.length > 0 && (
          <Box color="error.main">
            중복된 이메일: {duplicateEmails.join(", ")}
          </Box>
        )}
        {duplicateNames.length > 0 && (
          <Box color="error.main">중복된 이름: {duplicateNames.join(", ")}</Box>
        )}
        <Table stickyHeader aria-label="sticky table" onPaste={handlePaste}>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>이름</TableCell>
              <TableCell>이메일</TableCell>
              <TableCell>지역</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userList.map((user, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <TextField
                    value={user.name}
                    onChange={(e) =>
                      handleUserChange(index, "name", e.target.value)
                    }
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={user.email}
                    onChange={(e) =>
                      handleUserChange(index, "email", e.target.value)
                    }
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={user.region}
                    onChange={(e) =>
                      handleUserChange(index, "region", e.target.value)
                    }
                    size="small"
                    fullWidth
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} disabled={isPending}>
          취소
        </Button>
        <Button onClick={handleAddStudents} disabled={isPending}>
          추가
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDialog;
